<div class="mainDashboardPage">
    <div class="mainDashboard-container">

        <div class="header-flex">
            <div class="header-title">
                <h1>Dashboard</h1>
            </div>

            <div class="header-date">
                <div class="date-oval">
                    <mat-icon>calendar_today</mat-icon>
                    <span>{{ date }}</span>
                </div>
            </div>
        </div>
        
        <div class="main-flex">

            <div class="cards-flex">
                <mat-card class="mainDashboard-user-card">
                    <mat-card-content>
                        <user-card [totalLocations]="dashboardDataResponse.totalLocations" [totalGeofences]="dashboardDataResponse.totalGeofences" ></user-card>
                    </mat-card-content>
                </mat-card>

                <mat-card class="mainDashboard-card">
                    <mat-card-content>
                        <locations-card [dashboardDataResponse]="dashboardDataResponse"></locations-card>
                    </mat-card-content>
                </mat-card>

                <!-- <mat-card class="mainDashboard-card">
                    <mat-card-content>
                        <requests-card></requests-card>
                    </mat-card-content>
                </mat-card> -->

                <mat-card class="mainDashboard-card">
                    <mat-card-content>
                        <alerts-card [dashboardAlarms]="dashboardDataResponse.alarms"></alerts-card>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="table-flex">
                <mat-card class="container-alarmsByDayByMonth" style="width: 100%;">
                    <mat-card-content style="overflow-y: auto;">
                        <alarm-chart [dashboardAlarms]="dashboardDataResponse.alarms"></alarm-chart>
                    </mat-card-content>
                </mat-card>

            </div>

        </div>
    </div>
</div>